import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const PreviewModal: React.FC<Props> = ({ open, onClose, title, content }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #F0F0F0",
          py: 1.5,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: "#FFE8E3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NotificationsNoneOutlinedIcon
              sx={{ color: "#D91F05", fontSize: 18 }}
            />
          </Box>
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
            Pré-visualização da notificação
          </Typography>
        </Box>

        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 4, py: 3 }}>
        <Grid container spacing={4} alignItems="stretch">
          {/* Coluna esquerda: título + mensagem */}
          <Grid item xs={12}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, my: 2, fontSize: 24 }}
              >
                {title}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  whiteSpace: "pre-line", // respeita quebras de linha no texto
                  fontSize: 14,
                  lineHeight: 1.6,
                  color: "#444444",
                }}
              >
                <RichTextDisplay content={content} />
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewModal;
